import addWindowScrollPositionToDocument from './modules/viewport';
import toggle from './modules/toggle';
import './modules/modal';
import './modules/offerte-modal';
import './modules/callback-modal';
import './modules/submenu';
import slideIn from "./modules/slideIn";
import carousels from './modules/carousels';
import initFilters from "./modules/productFilter";
import initQuickSearch from "./modules/quickSearchFilter";
import initForms from './modules/forms';
import initCookieConsent from './modules/cookie-consent';

try {
    window.$ = window.jQuery = require('jquery');

    // Bootstrap elements example
    // require('bootstrap');
} catch (e) {
}

addWindowScrollPositionToDocument();
toggle();
initFilters();
initQuickSearch();
initForms();
initCookieConsent();
slideIn.slide('.forklift');
carousels.professionals();
carousels.news();
carousels.productgroups();
carousels.brands();
carousels.products();
carousels.blockSlides();
carousels.gallery();
